import { GridCellParams } from '@mui/x-data-grid';
import { Typography } from '@mui/material';
import { getConnectionColor } from '../utils/tableHelpers';

import { useSwitches } from 'features/switches/api/getSwitches';
import { useAnalyzers } from 'features/analyzers/api/getAnalyzers';

const useSetupSwitchesTable = (
  switchName: string,
  analyzerSwitchName: string
) => {
  const { data: switches } = useSwitches({});
  const { data: analyzers } = useAnalyzers({});
   let uniqueKeyCounter = 0;
  const columns = [
    { field: 'id', hide: true },
    {
      field: 'name',
      headerName: 'Device Name',
      width: 180,
      headerClassName: 'system-page--header',
    },
    {
      field: 'ip',
      headerName: 'IP',
      width: 180,
      headerClassName: 'system-page--header',
    },
    {
      field: 'analyzer',
      headerName: 'Connected Analyzer',
      width: 180,
      headerClassName: 'system-page--header',
    },
    {
      field: 'port',
      headerName: 'Analyzer Port',
      width: 150,
      headerClassName: 'system-page--header',
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 150,
      headerClassName: 'system-page--header',
      renderCell: (params: GridCellParams) => {
        const matchingSwitch = switches?.find(
          (item) => item?.id === params.row.id
        );
        return (
          <Typography
            variant='subtitle2'
            style={{ color: getConnectionColor(matchingSwitch) }}
          >
            {matchingSwitch?.enabled ? 'Connected' : 'Disconnected'}
          </Typography>
        );
      },
    },
  ];
  const rows: any[] = [];
  for (const oneSwitch of switches || []) {
    if (
      switchName &&
      !oneSwitch.name?.toLowerCase().includes(switchName.toLowerCase())
    )
      continue;
    if (oneSwitch.analyzer_switch && oneSwitch.analyzer_switch.length > 0) {
      for (const channel of oneSwitch.analyzer_switch) {
        const analyzer = analyzers?.find(
          (analyzer) => analyzer.id === channel.analyzer_id
        );
        if (
          analyzerSwitchName &&
          !analyzer?.name
            ?.toLowerCase()
            .includes(analyzerSwitchName.toLowerCase())
        )
          continue;
        rows.push({
          ...oneSwitch,
          analyzer: analyzer?.name,
          port: channel.switch_channel,
          id: uniqueKeyCounter++,
        });
      }
    } else {
      if (analyzerSwitchName) continue;
      rows.push({
        ...oneSwitch,
        port: 'None',
        analyzer: 'None',
        id: uniqueKeyCounter++,
      });
    }
  }
  return { rows, columns };
};

export default useSetupSwitchesTable;
